import { MessageList } from 'semantic-ui-react'

const List = ({ children }) => {
    return (
      <MessageList>
          {children}
      </MessageList>
    )
}

export { List }
